<svg width="100%" height="100%" [attr.viewBox]="viewBox" class="donut-container" [ngClass]="customClasses">
  <filter id="drop-shadow" x="0" y="0" width="100%" height="100%" filterUnits="userSpaceOnUse">
    <feDropShadow dx="2" dy="2" stdDeviation="1" flood-color="#757575" flood-opacity="0.3" />
  </filter>
  @if (dropShadow) {
    <circle
      class="donut-inner"
      cx="50%"
      cy="50%"
      [attr.r]="donutRadius"
    style="filter: url(#drop-shadow)"></circle>
  }
  @for (segment of donutChartSegments; track segment) {
    <ng-container>
      <circle
        class="donut-segment"
        [ngClass]="segment.circleClass"
        cx="50%"
        cy="50%"
        [attr.r]="donutRadius"
        fill="transparent"
        [attr.stroke-width]="strokeWidth"
        [attr.stroke]="segment.dashColor"
        [attr.stroke-dasharray]="segment.dashArray"
        [attr.stroke-dashoffset]="segment.dashOffset"
      [attr.stroke-linecap]="strokeLinecap"></circle>
    </ng-container>
  }
  <g class="donut-label">
    @if (centerMainText) {
      <text x="50%" y="50%" class="donut-main-text" [ngClass]="labelCustomClasses">
        {{ centerMainText }}
      </text>
    }
    @if (centerSecondaryText) {
      <text x="50%" y="50%" class="donut-secondary-text" [ngClass]="labelCustomClasses">
        {{ centerSecondaryText }}
      </text>
    }
  </g>
</svg>
@if (!!logo) {
  <img
    class="donut-logo"
    [src]="logo.logoSrc"
    [style.width.px]="logo.logoWidth"
    (error)="img.src = logo.logoDefault"
    [attr.alt]="logo.logoAlt"
    #img />
}
